<template>
  <div class="sidecart-content">
    <div v-if="cart.lines && cart.lines.length > 0">
      <CartItem
        v-for="(line, index) in cart.lines"
        :key="`cart-item-${line.id}`"
        :line="line"
        :index="index"
        :is-checkout="isCheckout"
        :toggle-side-cart-on-update="toggleSideCartOnUpdate"
        :toggle-side-cart-on-click="toggleSideCartOnClick"
        :show-remove-text="showRemoveText"
        v-bind="$attrs"
      />
    </div>
    <div v-else class="empty-cart-message">
      <div class="row">
        <div class="columns">
          <strong>Nothing here yet</strong><br />
          <a v-if="showEmptyLink" href="/">Check out our favorites.</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CartContent',
  components: {
    CartItem: defineAsyncComponent(() => import('@/components/Cart/CartItem')),
  },
  props: {
    toggleSideCartOnUpdate: {
      type: Boolean,
      required: false,
      default: true,
    },
    toggleSideCartOnClick: {
      type: Boolean,
      required: false,
      default: true,
    },
    showEmptyLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    showRemoveText: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCheckout: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['cart']),
  },
}
</script>
